import Router from "vue-router";
import Vue from "vue";
import index from "@/views/home/home";
import home from "@/views/home/index";
import sim from "@/views/sim/";
import purchase from "@/views/purchase/";
import customer from "@/views/customer/";
import risk from "@/views/risk/";
import login from '@/views/login/';
import record from '@/views/record/'
import virtualCurrency from '@/views/virtualCurrency/virtualCurrency.vue';
import renewManage from '@/views/renewManage/index.vue';
import renewPrice from '@/views/renewManage/renewPrice.vue';
import userRecoard from '@/views/renewManage/userRecoard.vue';
import renewTable from '@/views/renewManage/renewTable.vue';
import associatedLog from '@/views/renewManage/associatedLog.vue';
import snContact from '@/views/snContact/snContact.vue';
import renewalPriceManage from '@/views/renewalPriceManage/index.vue';


Vue.use(Router);

export default new Router({
  routes: [{
      path: "/",
      name: "index",
      component: index
    },
    {
      path: '/login',
      name: 'login',
      component: login
    },
    {
      path: "/web",
      name: "home",
      redirect: '/web/sim',
      component: home,
      children: [{
          path: "sim",
          name: "sim",
          component: sim
        },
        {
          path: 'record',
          name: "record",
          component: record
        },
        {
          path: "purchase",
          name: "purchase",
          component: purchase
        },
        {
          path: "customer",
          name: "customer",
          component: customer
        },
        {
          path: "snContact",
          name: "snContact",
          component: snContact
        },
        {
          path: "risk",
          name: "risk",
          component: risk
        },
        {
          path: "virtualCurrency",
          name: "virtualCurrency",
          component: virtualCurrency
        },
        {
          path: "/renewManage/renewTable",
          name: "renewTable",
          component: renewTable
        },
        {
          path: "/renewManage/associatedLog",
          name: "associatedLog",
          component: associatedLog
        },
        {
          path: "/renewalPriceManage/index",
          name: "renewalPriceManage",
          component: renewalPriceManage
        },
        {
          path: "renewManage",
          name: "renewManage",
          component: renewManage,
          redirect: '/renewManage/userRecoard',
          children: [{
              path: "/renewManage/renewPrice",
              name: "renewPrice",
              component: renewPrice
            },
            {
              path: "/renewManage/userRecoard",
              name: "userRecoard",
              component: userRecoard
            },
            
          ]
        },

      ]
    }
  ]
});
